import dayjs from '~/utils/dayjs'

export const firstCharToUpperCase = (str: string): string => {
  return `${str.charAt(0).toUpperCase()}${str.slice(1).toLocaleLowerCase()}`
}

export const capitalize = (str?: string): string => {
  if (str) {
    return str
      .split(' ')
      .map((substr) => firstCharToUpperCase(substr))
      .join(' ')
  }

  return ''
}

export const formatExportFileName = (fileName: string): string => {
  return `${fileName}_${dayjs().format('DD-MM-YYYY')}`
}

export const truncate = (value: string, numberOfChar = 8): string => {
  return value.slice(0, numberOfChar)
}

export const isValidHexColor = (value: string): boolean => /^#[0-9A-F]{6}$/i.test(value.slice(0, 7))
